"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shortenResourceCalendarTitle = void 0;
// カレンダーの長い名前を短縮する
// ウォンバットテクノロジー本社-1-セクション1-ウォンバットの間 (5)
// → ウォンバットの間 (5)
const shortenResourceCalendarTitle = (title) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const match = title.match(/[^-]*$/);
    return match[0];
};
exports.shortenResourceCalendarTitle = shortenResourceCalendarTitle;
//# sourceMappingURL=shortenResourceCalendarTitle.js.map